import { render, staticRenderFns } from "./AmendmentDetails.vue?vue&type=template&id=71e850ea&scoped=true&"
import script from "./AmendmentDetails.vue?vue&type=script&lang=js&"
export * from "./AmendmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AmendmentDetails.vue?vue&type=style&index=0&id=71e850ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e850ea",
  null
  
)

export default component.exports